export default __webpack_public_path__ + "static/media/MYSQL_AGENT.f4e42901.jpg";